import { render, staticRenderFns } from "./studyCoursedetails.vue?vue&type=template&id=859128c6&scoped=true&"
import script from "./studyCoursedetails.vue?vue&type=script&lang=js&"
export * from "./studyCoursedetails.vue?vue&type=script&lang=js&"
import style0 from "./studyCoursedetails.vue?vue&type=style&index=0&id=859128c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859128c6",
  null
  
)

export default component.exports